import React, {PureComponent} from 'react';
import {withTranslation} from 'react-i18next';
import Button from "react-bootstrap/Button";
import Connect from "react-redux/es/connect/connect";
import '../index.css';
import './index.css'
import {KeyboardDateTimePicker, MuiPickersUtilsProvider,} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import PropTypes from 'prop-types';
import {
	alertError,
	alertSuccess,
	createArticle,
	editArticle,
	editLayout,
	editorHasText,
	getLayouts,
	getSchoolArticleLayouts
} from "../../../../actions";
import {
	dispatchOnCreateArticlesApproveArticle,
	dispatchOnCreateArticlesApproveArticleFailure,
	dispatchOnCreateArticlesApproveArticleSuccess,
	dispatchOnCreateArticlesArticleToEditChanged,
	dispatchOnCreateArticlesAuthorChanged,
	dispatchOnCreateArticlesBodyChanged,
	dispatchOnCreateArticlesCanShowUnsavedChangesModalChanged,
	dispatchOnCreateArticlesCreatingNewChanged,
	dispatchOnCreateArticlesDiscardEditingArticle,
	dispatchOnCreateArticlesDiscardNewArticle,
	dispatchOnCreateArticlesDiscardUnsavedEditingArticle,
	dispatchOnCreateArticlesFormErrors,
	dispatchOnCreateArticlesGetSchoolArticlesLayouts,
	dispatchOnCreateArticlesGetSchoolArticlesLayoutsFailure,
	dispatchOnCreateArticlesGetSchoolArticlesLayoutsSuccess,
	dispatchOnCreateArticlesHasAuthorRightsChanged,
	dispatchOnCreateArticlesHasUnsavedChangesChanged,
	dispatchOnCreateArticlesImagesChanged,
	dispatchOnCreateArticlesIsBodyShowingChanged,
	dispatchOnCreateArticlesIsSelectingImagesChanged,
	dispatchOnCreateArticlesIsSelectingMainImageChanged,
	dispatchOnCreateArticlesLayoutChanged,
	dispatchOnCreateArticlesLayoutsChanged,
	dispatchOnCreateArticlesLeadChanged,
	dispatchOnCreateArticlesMainImageChanged,
	dispatchOnCreateArticlesPublishDateChanged,
	dispatchOnCreateArticlesPublishingArticleChanged,
	dispatchOnCreateArticlesSaveArticle,
	dispatchOnCreateArticlesSaveArticleFailure,
	dispatchOnCreateArticlesSaveArticleSuccess,
	dispatchOnCreateArticlesSavingArticleChanged,
	dispatchOnCreateArticlesSavingDraftChanged,
	dispatchOnCreateArticlesSectionChanged,
	dispatchOnCreateArticlesSectionsChanged,
	dispatchOnCreateArticlesSetArticleToEditChanged,
	dispatchOnCreateArticlesShowAddToPresentation,
	dispatchOnCreateArticlesShowHasAuthorRightsModalChanged,
	dispatchOnCreateArticlesStraplineChanged,
	dispatchOnCreateArticlesSubmitArticle,
	dispatchOnCreateArticlesSubmitArticleFailure,
	dispatchOnCreateArticlesSubmitArticleSuccess,
	dispatchOnCreateArticlesTitleChanged,
	getAllowedArticleLayouts
} from "./functions";
import MultimediaModal from "../../../modals/multimedia/multimediaModal";
import {
	debug,
	find,
	formatDateTimeEUtoUS,
	isFieldInArray,
	removeAt,
	removeObjectWithFieldInArray
} from "../../../../utility/functions";
import Config from "../../../../config";
import Trash from '../../../../assets/trash.png';
import Edit from '../../../../assets/edit.png';
import ArrowDown from '../../../../assets/arrow-down-black.png';
import ArrowUp from '../../../../assets/arrow-down-black.png';
import GalleryIcon from '../../../../assets/news_gallery_black.png';
import Loading from "../../../subComponents/GenericLoading/loading";
import SuperModal from "../../../subComponents/GenericModal/superModal";
import {
	dispatchOnMultimediaClearSelectedFiles,
	dispatchOnMultimediaSetSelectedFile
} from "../../../multimedia/functions";
import {getItem, keys} from "../../../../localStorage";
import {requiredFieldsForArticleUpload, requiredFieldsForGalleryUpload} from "./reducer";
import Image from "react-bootstrap/Image";
import Select from "react-select";
import makeAnimated from "react-select/animated/dist/react-select.esm";
import {
	dispatchOnPresentationGetLayouts,
	dispatchOnPresentationGetLayoutsFailure,
	dispatchOnPresentationGetLayoutsSuccess
} from "../../../presentation/functions";
import {NewsBodyEditor} from "../../../../components/NewsBodyEditor";

const actions = {
	current: 'none',
	save: "save",
	submit: "submit",
	approve: "approve",
};

const DRAFT = "Rascunho";
const PUBLISHED = "Publicado";
const TO_APPROVE = "Por aprovar";
const SCHEDULED = "Agendado";


class CreateNewArticleMultimedia extends PureComponent {
	// Native component functions

	componentDidMount() {
		this.getLayouts();
		this.onGetSchoolArticleLayouts();
		if (this.props.hasUnsavedChanges) {
			this.props.dispatchOnCreateArticlesCanShowUnsavedChangesModalChanged(true)
		}
	}

	componentWillUnmount() {
		this.props.dispatchOnCreateArticlesFormErrors(null);
	}

	// Custom component functions

	onGetSchoolArticleLayouts = () => {
		const {mode} = this.props;
		this.props.dispatchOnCreateArticlesGetSchoolArticlesLayouts();
		getSchoolArticleLayouts()
			.then(response => {
				const allowedLayouts = getAllowedArticleLayouts(mode);
				const layouts = response.data.filter(value => {
					return allowedLayouts.includes(value.path);
				});
				this.props.dispatchOnCreateArticlesGetSchoolArticlesLayoutsSuccess(layouts);
			})
			.catch(error => {
				this.props.dispatchOnCreateArticlesGetSchoolArticlesLayoutsFailure(error);
			})
	};

	getLayouts = () => {
		this.props.dispatchOnPresentationGetLayouts();
		getLayouts()
			.then((response) => {
				debug("request", response);
				const sections = Object.keys(response.data)
					.filter(value => typeof response.data[value] === "string")
					.map(value => response.data[value]);


				const sectionsList = [];
				sections.forEach((value, index) => {
					sectionsList.push({
						value: "content_" + (index + 1) + "_array",
						label: value
					})
				});

				this.props.dispatchOnCreateArticlesSectionChanged(sectionsList[0]);
				this.props.dispatchOnCreateArticlesSectionsChanged(sectionsList);
				this.props.dispatchOnPresentationGetLayoutsSuccess(response);
			})
			.catch((error) => {
				this.props.dispatchOnPresentationGetLayoutsFailure();
			})

	};

	// This function attempts to create a new article with the data provided from the html page

	onCreateArticle = (action, extraProps) => {
		const {savingArticle, submitingArticle, approvingArticle} = this.props;
		const article = this.getArticleToSave(extraProps);
		if (!article) return;
		if(savingArticle || submitingArticle || approvingArticle) return null;

		switch (action) {
			case actions.save:
				this.props.dispatchOnCreateArticlesSaveArticle();
				break;
			case actions.submit:
				this.props.dispatchOnCreateArticlesSubmitArticle();
				break;
			case actions.approve:
				this.props.dispatchOnCreateArticlesApproveArticle();
				break;
			default:
				break;
		}

		createArticle(article)
			.then((response) => {
				debug("Created article with success", response);
				alertSuccess(response.message);
				switch (action) {
					case actions.save:
						this.props.dispatchOnCreateArticlesSaveArticleSuccess();
						break;
					case actions.submit:
						this.props.dispatchOnCreateArticlesSubmitArticleSuccess();
						break;
					case actions.approve:
						this.props.dispatchOnCreateArticlesApproveArticleSuccess();
						break;
					default:
						break;
				}
				this.props.dispatchOnCreateArticlesSetArticleToEditChanged(response.data)
			})
			.catch((error) => {
				alertError(error.error);
				switch (action) {
					case actions.save:
						this.props.dispatchOnCreateArticlesSaveArticleFailure(error);
						break;
					case actions.submit:
						this.props.dispatchOnCreateArticlesSubmitArticleFailure(error);
						break;
					case actions.approve:
						this.props.dispatchOnCreateArticlesApproveArticleFailure(error);
						break;
					default:
						break;
				}
			})
	};

	onEditArticle = (action, extraProps) => {
		const {articleToEdit, savingArticle, submitingArticle, approvingArticle} = this.props;
		const article = this.getArticleToSave(extraProps);
		if (!article) return;

		if(savingArticle || submitingArticle || approvingArticle) return null;

		switch (action) {
			case actions.save:
				this.props.dispatchOnCreateArticlesSaveArticle();
				break;
			case actions.submit:
				this.props.dispatchOnCreateArticlesSubmitArticle();
				break;
			case actions.approve:
				this.props.dispatchOnCreateArticlesApproveArticle();
				break;
			default:
				break;
		}
		editArticle(find(articleToEdit, 'id'), article)
			.then(response => {

				alertSuccess(response.message)
				switch (action) {
					case actions.save:
						this.props.dispatchOnCreateArticlesSaveArticleSuccess();
						break;
					case actions.submit:
						this.props.dispatchOnCreateArticlesSubmitArticleSuccess();
						break;
					case actions.approve:
						this.props.dispatchOnCreateArticlesApproveArticleSuccess();
						break;
					default:
						break;
				}
				this.props.dispatchOnCreateArticlesSetArticleToEditChanged(response.data)
			})
			.catch(error => {
				alertError(error.error);
				switch (action) {
					case actions.save:
						this.props.dispatchOnCreateArticlesSaveArticleFailure(error);
						break;
					case actions.submit:
						this.props.dispatchOnCreateArticlesSubmitArticleFailure(error);
						break;
					case actions.approve:
						this.props.dispatchOnCreateArticlesApproveArticleFailure(error);
						break;
					default:
						break;
				}
			})
	};

	editLayout = () => {
		const {newLayout, section, articleToEdit} = this.props;

		newLayout[section.value].push({id: find(articleToEdit, 'article_id'), title: find(articleToEdit, 'title')});
		if (!newLayout) return null;
		editLayout(newLayout)
			.then((response) => {
				this.props.dispatchOnCreateArticlesSectionChanged(null);
				debug("response save layout -> ", response)
			})
			.catch((error) => {
				debug("error save layout -> ", error)
			})

	};

	onSaveButtonPressed = () => {
		this.onSaveArticle();
	};

	onSaveArticle = () => {
		if (this.isNewArticle()) {
			this.onCreateArticle(actions.save, {draft: 1})
		} else {
			this.onEditArticle(actions.save)
		}
	};

	onSubmitButtonPressed = () => {
		actions.current = actions.submit;
		this.props.dispatchOnCreateArticlesShowHasAuthorRightsModalChanged(true);
	};

	onSubmitArticle = () => {
		if (this.isNewArticle()) {
			if(getItem(keys.role) === '1') {
				this.onCreateArticle(actions.submit, {draft: 0, public: 1})
			} else {
				this.onCreateArticle(actions.submit, {draft: 0})
			}
		} else {
			if(getItem(keys.role) === '1') {
				this.onEditArticle(actions.submit, {draft: 0, public: 1})
			} else {
				this.onEditArticle(actions.submit, {draft: 0})
			}
		}
	};

	onApproveButtonPressed = () => {
		actions.current = actions.approve;
		this.props.dispatchOnCreateArticlesShowHasAuthorRightsModalChanged(true);
	};

	onApproveArticle = () => {
		if (this.isNewArticle()) {
			this.onCreateArticle(actions.approve, {public: 1})
		} else {
			this.onEditArticle(actions.approve, {public: 1})
		}
	};

	getArticleType = () => {
		if (this.isArticlePublished()) {
			return PUBLISHED;
		}

		if (this.isArticleWaitingApproval()) {
			return TO_APPROVE;
		}

		if (this.isArticleScheduled()) {
			return SCHEDULED;
		}

		return DRAFT;
	};

	// Called when onBackButtonPressed button is pressed
	onBackButtonPressed = () => {
		this.props.history.goBack();
		//this.props.dispatchOnCreateArticlesResetToDefaults()
	};

	onSelectedImagesForGallery = (files) => {
		const {articleToEdit} = this.props;

		if (this.isNewArticle()) {
			this.props.dispatchOnCreateArticlesImagesChanged(files);
		} else {
			this.props.dispatchOnCreateArticlesArticleToEditChanged({...articleToEdit, images: files})
		}
		this.props.dispatchOnMultimediaClearSelectedFiles();
		this.props.dispatchOnCreateArticlesIsSelectingImagesChanged(false)
	};

	onSelectedMainImage = (mainImage) => {
		const {articleToEdit} = this.props;
		if (!this.isNewArticle()) {
			this.props.dispatchOnCreateArticlesArticleToEditChanged({...articleToEdit, mainImage})
		} else {
			this.props.dispatchOnCreateArticlesMainImageChanged(mainImage);
		}
		this.props.dispatchOnMultimediaClearSelectedFiles();
		this.props.dispatchOnCreateArticlesIsSelectingMainImageChanged(false)
	};

	onGalleryImagesRemoveButtonPressed = (e, index, img) => {
		e.stopPropagation();
		const {images, articleToEdit} = this.props;
		if (!this.isNewArticle()) {
			this.props.dispatchOnCreateArticlesArticleToEditChanged({
				...articleToEdit,
				images: removeAt(images, index)
			});
		} else {
			this.props.dispatchOnCreateArticlesImagesChanged(removeAt(images, index));
		}
	};

	isCreatingNewArticle = () => {
		if (this.props.strapline.length !== 0) return true;
		if (this.props.title.length !== 0) return true;
		if (this.props.lead.length !== 0) return true;
		if (editorHasText(this.props.body)) return true;
		if (this.props.mainImage) return true;
		return false;
	};

	isArticleWaitingApproval = () => {
		return find(this.props.articleToEdit, 'public') === "0" && find(this.props.articleToEdit, 'draft') === 0
	};

	isArticleScheduled = () => {
		return find(this.props.articleToEdit, 'public') === "1" && find(this.props.articleToEdit, 'scheduled') === 1
	};

	isArticlePublished = () => {
		return find(this.props.articleToEdit, 'public') === "1" && find(this.props.articleToEdit, 'scheduled') === 0
	};

	isNewArticle = () => {
		return this.props.articleToEdit === null;
	};

	getArticleToSave = (extraProps) => {
		const {strapline, title, lead, body, author, layout, publishedDate, articleToEdit} = this.props;

		const validArticle = this.isArticleValidForUpload(true);
		if (validArticle) {
			const isEditing = !this.isNewArticle();
			return {
				strapline: isEditing ? find(articleToEdit, 'strapline') : strapline,
				title: isEditing ? find(articleToEdit, 'title') : title,
				lead: isEditing ? find(articleToEdit, 'lead') : lead,
				body: isEditing ? find(articleToEdit, 'body') : body,
				image_id: this.getMainImageId(),
				author: isEditing ? find(articleToEdit, 'author') : author,
				layout: isEditing ? find(articleToEdit, 'layout') ? find(articleToEdit, 'layout.id') : null : layout ? layout.id : null,
				publishedDate: isEditing ? find(articleToEdit, 'publishedDate') : publishedDate,
				images: this.getImagesIds(),
				...extraProps
			};
		}
		return null
	};

	isArticleValidForUpload = () => {
		const errors = [];
		const keys = this.props.mode === "normal" ? requiredFieldsForArticleUpload : requiredFieldsForGalleryUpload;
		const article = this.isNewArticle() ? this.props : this.props.articleToEdit;

		keys.forEach((value) => {
			if (value === 'body') {
				if (!editorHasText(find(article, value))) {
					errors.push({
						[value]: "Este campo é obrigatório"
					})
				}
			}
			if (find(article, value) === undefined || find(article, value) === null || find(article, value) === "" || find(article, value).length === 0) {
				errors.push({
					[value]: "Este campo é obrigatório"
				})
			}
		});

		this.props.dispatchOnCreateArticlesFormErrors(errors);
		if (errors.length !== 0) {
			alertError("Termine de preencher todos os campos obrigatórios antes de submeter o artigo");
			return false;
		}
		return true;
	};

	getErrorMessages = (key) => {
		const {errors} = this.props;
		if (!errors || errors.length === 0) return null;

		const errorMessages = errors.filter((value) => {
			return find(value, key) !== undefined
		}).map((value) => {
			return find(value, key);
		});

		return this.stringifyArrayOfStrings(errorMessages);
	};

	stringifyArrayOfStrings = (array) => {
		if (array.length === 0) return "";
		if (array.length === 1) return array[0];
		return array.reduce((oldValue, newNalue) => oldValue += "\n" + newNalue)
	};

	getMainImageId = (image = null) => {
		const {articleToEdit, mainImage} = this.props;

		if (image) {
			return find(image.image, 'id');
		}

		if (!this.isNewArticle()) {
			const articleMainImage = find(articleToEdit, 'mainImage')
			if (articleToEdit && articleMainImage) {
				if (find(articleMainImage, 'image')) {
					return find(articleMainImage.image, 'id');
				} else {
					return find(articleMainImage, 'id');
				}

			}
		} else {
			if (mainImage) {
				return find(mainImage.image, 'id');
			}
		}
		return null;
	};

	getImagesIds = () => {
		const images = !this.isNewArticle() ? find(this.props.articleToEdit, 'images') : this.props.images;
		if (!images) return null;
		const imgs = [];
		images.forEach((value) => {
			const imgId = this.getMainImageId(value);
			if (imgId) {
				imgs.push(imgId)
			}
		});
		if (imgs.length > 0) return imgs;
		return null;
	};

	// Native component render function

	onDiscardChanges = () => {
		if (this.isNewArticle()) {
			this.props.dispatchOnCreateArticlesDiscardNewArticle();
		} else {
			this.props.dispatchOnCreateArticlesDiscardEditingArticle(this.props);
		}
		this.props.dispatchOnCreateArticlesHasUnsavedChangesChanged(false)
		this.props.dispatchOnCreateArticlesCanShowUnsavedChangesModalChanged(false)
	};

	getValue = (key) => {
		return this.isNewArticle() ? this.props[key] : find(this.props.articleToEdit, key);
	};

	onPresentationSectionChanged = (section) => {
		this.props.dispatchOnCreateArticlesSectionChanged(section)
	};

	render() {
		const {t, mode} = this.props;

		const subTitle = mode === 'normal'? t('New Multimedia News') : t('New Gallery News');

		return (
			<div>
				<div className="container">
					<div className="container-header">
						<div className="container-header-tittle"><h2>{t('News')}</h2></div>
						<div className='container-header-arrow'>{">"}</div>
						<div className="container-header-subtittle">{subTitle}</div>
					</div>
					<div className="container-body container-body-multimedia">
						{this.renderMainInputs()}
						<div className="container-body-multimedia-division"></div>
						{this.renderSecondaryInputs()}
					</div>
					<hr style={{background: 'black', height: 1}}/>
					{this.renderActions()}
				</div>
				{this.renderSelectMainImageModal()}
				{this.renderSelectMultimediaImagesModal()}
				{this.renderHasChangesModal()}
				{this.renderConfirmAuthorRightsModal()}
				{this.renderAddArticleToPresentation()}
			</div>
		);
	}

	// Custom component render functions

	renderMainInputs = () => {
		return (
			<div className="container-body-multimedia-main-inputs">
				{this.renderStraplineInput()}
				{this.renderTitleInput()}
				{this.renderLeadInput()}
				{this.renderGalleryInput()}
				{this.renderGalleryAndBodyDevider()}
				{this.renderBodyInput()}
			</div>
		)
	};

	renderStraplineInput = () => {
		const {t, articleToEdit} = this.props;
		const errors = this.getErrorMessages("strapline");
		const subText = errors ? t(errors) : "Título secundário colocado por cima do título numa notícia";
		const className = errors ? " input-with-errors" : "";
		const subTextClassName = errors ? " input-sub-text-with-errors" : "";
		const onChange = (e) => {
			const newValue = e.target.value;
			if (this.isNewArticle()) {
				this.props.dispatchOnCreateArticlesStraplineChanged(newValue)
			} else {
				this.props.dispatchOnCreateArticlesArticleToEditChanged({
					...articleToEdit,
					strapline: newValue
				})
			}
			if (newValue.length > 0 && isFieldInArray(this.props.errors, 'strapline')) {
				this.props.dispatchOnCreateArticlesFormErrors(removeObjectWithFieldInArray(this.props.errors, 'strapline'));
			}
		};

		return (
			<div className="input-div">
				<label className='input-label'>{"* " + t("Strapline")}</label>
				<input
					className={"input" + className} placeholder={"Por favor introduz um " + t("Strapline")} name={"strapline"}
					value={this.getValue('strapline')}
					onChange={onChange}
				/>
				<div className={"input-sub-text" + subTextClassName}>{subText}</div>
			</div>
		);
	};

	renderTitleInput = () => {
		const {t, articleToEdit} = this.props;
		const errors = this.getErrorMessages("title");
		const subText = errors ? t(errors) : "Deve anunciar o texto e captar a atenção do leitor para o conteúdo ";
		const className = errors ? " input-with-errors" : "";
		const subTextClassName = errors ? " input-sub-text-with-errors" : "";
		const onChange = (e) => {
			const newValue = e.target.value;
			if (this.isNewArticle()) {
				this.props.dispatchOnCreateArticlesTitleChanged(newValue)
			} else {
				this.props.dispatchOnCreateArticlesArticleToEditChanged({
					...articleToEdit,
					title: newValue
				});
			}
			if (newValue.length > 0 && isFieldInArray(this.props.errors, 'title')) {
				this.props.dispatchOnCreateArticlesFormErrors(removeObjectWithFieldInArray(this.props.errors, 'title'));

			}
		};

		return (
			<div className="input-div">
				<label className='input-label'>{"* " + t("Title")}</label>
				<input
					className={"input" + className} placeholder={"Por favor introduz um " + t("Title")} name={"title"}
					value={this.getValue('title')}
					onChange={onChange}
				/>
				<div className={"input-sub-text" + subTextClassName}>{subText}</div>
			</div>
		);
	};

	renderLeadInput = () => {
		const {t, articleToEdit} = this.props;
		const errors = this.getErrorMessages("lead");
		const subText = errors ? t(errors) : "Parágrafo inicial que introduz de forma concisa e objetiva o assunto que se desenvolve na notícia";
		const className = errors ? " input-with-errors" : "";
		const subTextClassName = errors ? " input-sub-text-with-errors" : "";
		const onChange = (e) => {
			const newValue = e.target.value;
			if (this.isNewArticle()) {
				this.props.dispatchOnCreateArticlesLeadChanged(newValue)
			} else {
				this.props.dispatchOnCreateArticlesArticleToEditChanged({
					...articleToEdit,
					lead: newValue
				});
			}
			if (newValue.length > 0 && isFieldInArray(this.props.errors, 'lead')) {
				this.props.dispatchOnCreateArticlesFormErrors(removeObjectWithFieldInArray(this.props.errors, 'lead'));

			}
		};

		return (
			<div className="input-div">
				<label className='input-label'>{"* " + t("Lead")}</label>
				<textarea
					className={"input" + className} placeholder={"Por favor introduz uma " + t('Lead')} name={"lead"}
					value={this.getValue('lead')} rows={3}
					onChange={onChange}
				/>
				<div className={"input-sub-text" + subTextClassName}>{subText}</div>
			</div>
		);
	};

	renderGalleryInput = () => {
		const {mode, images, articleToEdit} = this.props;
		const imgsToRender = this.isNewArticle() ? images : find(articleToEdit, 'images');
		if (mode === "gallery") {
			if (imgsToRender !== null && imgsToRender.length > 0) {
				return (
					<div
						id={"gallery-images"}
						className="inputClassMultimidia"
						onClick={() => {
							this.props.dispatchOnMultimediaSetSelectedFile(imgsToRender);
							this.props.dispatchOnCreateArticlesIsSelectingImagesChanged(true)
						}}
					>
						{this.renderGalleryImages(imgsToRender)}
					</div>
				)
			} else {
				return (
					<div
						className="inputClassMultimidia gallery-div"
						onClick={() => {
							this.props.dispatchOnCreateArticlesIsSelectingImagesChanged(true)
						}}
					>
						<div className="gallery-text">Adiciona imagens à galeria do artigo</div>
						<img className="gallery-image" src={GalleryIcon} alt={""}/>
					</div>
				)
			}
		}
	};

	renderGalleryImages = (images) => {
		return images.map((img, index) => {
			const rand = Math.ceil(10000 + Math.random() * (99999 - 10000));
			const src = Config.urlImages + find(img, 'src') + "?dummy=" + rand;
			return (
				<div className='files-container' id={'gallery-image-' + find(img, 'id')} key={'gallery-image-' + find(img, 'id')}>
					<div className="files-container-image">
						<img
							className='img-multimedia-files'
							src={src}
							alt={""}
						/>
					</div>
					<div className='files-container-bottom'>
						<span className="files-container-span">{find(img, 'name')}</span>
						<div className='files-container-actions'>
							<Image
								className='files-container-action-remove'
								id={'image' + find(img, 'id')}
								key={'image' + find(img, 'id')}
								src={Trash}
								onClick={(e) => {
									this.onGalleryImagesRemoveButtonPressed(e, index, img)
								}}
							/>
						</div>
					</div>
				</div>
			)
		})
	};

	renderBodyInput = () => {
		const {t, mode, articleToEdit, isBodyShowing} = this.props;
		if (mode === "normal" || (mode === "gallery" && isBodyShowing)) {
			const errors = this.getErrorMessages("body");
			const subText = errors ? t(errors) : "Trata-se da informação propriamente dita, com a exposição mais detalhada dos acontecimentos mencionados.";
			const subTextClassName = errors ? " input-sub-text-with-errors" : "";
			const onChange = (v) => {
				if (this.isNewArticle()) {
					this.props.dispatchOnCreateArticlesBodyChanged(v)
				} else {
					this.props.dispatchOnCreateArticlesArticleToEditChanged({...articleToEdit, body: v})
				}
				if (editorHasText(v) && isFieldInArray(this.props.errors, 'body')) {
					this.props.dispatchOnCreateArticlesFormErrors(removeObjectWithFieldInArray(this.props.errors, 'body'));
				}
			};

			const label = this.props.mode === 'normal'? "* " + t("Body") : t("Body");

			const editorNode = document.getElementById('articles-editor-div');
			if(editorNode) {
				/*if(errors) {
					editorNode.childNodes[2].classList.add('editorClassName-with-errors')
				} else {
					editorNode.childNodes[2].classList.remove('editorClassName-with-errors')
				}*/
			};

			const bodyHtml = this.getValue('body');

			return (
				<div id={'articles-editor-div'}>
					<label className='input-label'>{label}</label>
					<NewsBodyEditor
						initialHtml={bodyHtml}
						onChange={onChange}
					/>
					<div className={"input-sub-text" + subTextClassName}>{subText}</div>
				</div>
			)
		}
	};


	renderGalleryAndBodyDevider = () => {
		const {t, mode, isBodyShowing} = this.props;
		if (mode === "gallery") {
			return (
				<p
					style={{marginTop: 10}}
					onClick={() => {
						this.props.dispatchOnCreateArticlesIsBodyShowingChanged(!isBodyShowing)
					}}
				>
					{t("Body") + "  "}
					<img
						width={10}
						height={10}
						style={{tintColor: 'black', resize: 'contain'}}
						src={isBodyShowing? ArrowUp : ArrowDown}
						alt={""}
					/>
				</p>
			)
		}
	};

	renderSecondaryInputs = () => {
		const {t} = this.props;
		return (
			<div className="container-body-multimedia-sub-inputs">
				{this.renderMainImageInput()}
				{this.renderAuthorInput()}
				<div className="sub-input-div">
					<div className="sub-input-div-title">{t('Layout')}</div>
					{this.renderLayoutInput()}
				</div>

				<div className="sub-input-div">
					<div className="sub-input-div-title">{t('Schedule article')}</div>
					{this.renderPublishDateInput()}
				</div>
				{this.renderStatusInput()}
			</div>
		)
	};

	renderStatusInput = () => {
		const {t} = this.props;
		return (
			<div className="sub-input-div">
				<div className="sub-input-div-title">{t('Status')}</div>
				<div className="sub-input-status">
					{this.getArticleType()}
				</div>
			</div>
		)
	};

	renderMainImageInput = () => {
		const {t} = this.props;
		const value = this.getValue('mainImage');
		const className = value ? "" : " sub-input-featured-image"
		return (
			<div className={"sub-input-div" + className}>
				<div className="sub-input-div-title">{t('Featured Image')}</div>
				{this.renderMainImageContainer(value)}
			</div>
		)
	};

	renderMainImageContainer = (value) => {
		const errors = this.getErrorMessages("mainImage");
		const className = errors ? " sub-input-featured-image-container-image-with-error" : "";
		return (
			<div className={"sub-input-featured-image-container"}>
				<div className={"sub-input-featured-image-container-image" + className}>
					{this.renderMainImage(value, errors)}
				</div>
				{this.renderMainImageErrorText(errors)}
				{this.renderMainImageIcons(value)}
			</div>
		)
	};

	renderMainImage = (value) => {
		if (value) {
			if (value && isFieldInArray(this.props.errors, 'mainImage')) {
				this.props.dispatchOnCreateArticlesFormErrors(removeObjectWithFieldInArray(this.props.errors, 'mainImage'));
			}
			return (
				<img className={"img-responsive"} src={Config.urlImages + find(value, 'src')} alt={""}/>
			)
		} else {
			return (
				<div
					onClick={() => {
						this.props.dispatchOnCreateArticlesIsSelectingMainImageChanged(true)
					}}
				>
					<img src={GalleryIcon} alt={""}/>
				</div>
			)
		}
	};

	renderMainImageErrorText = (errors) => {
		const {t} = this.props;
		if (errors && errors.length > 0) {
			const subText = t(errors);
			const subTextClassName = errors ? " input-sub-text-with-errors" : "";
			return (
				<div className={"input-sub-text" + subTextClassName}>{subText}</div>
			)
		}
	};

	renderMainImageIcons = (value) => {
		const {articleToEdit} = this.props;
		if (value) {
			return (
				<div className={'sub-input-featured-image-container-actions'}>
					<img
						className="sub-input-featured-image-with-image-actions-icon" src={Edit}
						onClick={() => {
							this.props.dispatchOnCreateArticlesIsSelectingMainImageChanged(true)
						}} alt={""}/>
					<img
						className="sub-input-featured-image-with-image-actions-icon"
						src={Trash}
						alt={""}
						onClick={() => {
							if (this.isNewArticle()) {
								this.props.dispatchOnCreateArticlesMainImageChanged(null)
							} else {
								this.props.dispatchOnCreateArticlesArticleToEditChanged({
									...articleToEdit,
									mainImage: null
								});
							}
						}}/>
				</div>
			)
		}
	};

	renderAuthorInput = () => {
		const {t, articleToEdit} = this.props;
		const errors = this.getErrorMessages("author");
		const subText = t(errors);
		const className = errors ? " sub-input-author-with-error" : "";
		const subTextClassName = errors ? " input-sub-text-with-errors" : "";
		const onChange = (e) => {
			const newValue = e.target.value;
			if (this.isNewArticle()) {
				this.props.dispatchOnCreateArticlesAuthorChanged(newValue)
			} else {
				this.props.dispatchOnCreateArticlesArticleToEditChanged({
					...articleToEdit,
					author: newValue
				});
			}
			if (newValue.length > 0 && isFieldInArray(this.props.errors, 'author')) {
				this.props.dispatchOnCreateArticlesFormErrors(removeObjectWithFieldInArray(this.props.errors, 'author'));
			}
		};

		return (
			<div className="sub-input-div">
				<div className="sub-input-div-title">{t('Article Author')}</div>
				<div className="sub-input-div-container">
					<input
						className={"sub-input-author" + className} placeholder={t("Write the name")}
						name={"author"} value={this.getValue('author') || ""}
						onChange={onChange}
					/>
					<div className={"input-sub-text" + subTextClassName}>{subText}</div>
				</div>
			</div>
		);
	};

	renderLayoutInput = () => {
		const {t, articleToEdit} = this.props;
		const onChange = (value) => {
			if (this.isNewArticle()) {
				this.props.dispatchOnCreateArticlesLayoutChanged(value)
			} else {
				this.props.dispatchOnCreateArticlesArticleToEditChanged({...articleToEdit, layout: value})
			}
		};

		return (
			<select
				className="sub-input-layout"
				defaultValue={this.getValue('layout') || t("Select the layout")}
				onChange={onChange}
			>
				{this.renderLayouts()}
			</select>
		);
	};

	renderLayouts = () => {
		const {t, layouts} = this.props;
		if (!layouts || layouts.length === 0) return <option key={-1} value={-1}>{t("Pre-Defined")}</option>;
		return layouts.map((layout) =>
			<option key={find(layout, 'id')} value={find(layout, 'id')}>{find(layout, 'name')}</option>
		)
	};

	renderPublishDateInput = () => {
		const {articleToEdit} = this.props;
		const onChange = (date, value) => {
			if (this.isNewArticle()) {
				this.props.dispatchOnCreateArticlesPublishDateChanged(formatDateTimeEUtoUS(value))
			} else {
				this.props.dispatchOnCreateArticlesArticleToEditChanged({
					...articleToEdit,
					publishedDate: formatDateTimeEUtoUS(value)
				})
			}
		};

		return (
			<div className="sub-input-publish-date">
				<MuiPickersUtilsProvider utils={DateFnsUtils}>
					<KeyboardDateTimePicker
						format="dd/MM/yyyy HH:mm"
						value={this.getValue('publishedDate')}
						onChange={onChange}
					/>
				</MuiPickersUtilsProvider>
			</div>
		);
	}

	renderActions = () => {
		return (
			<div className="container-body-multimedia-actions ">
				<div className="container-body-multimedia-actions-left">
					{this.renderMainAction()}
				</div>
				<div className="container-body-multimedia-actions-right">
					{this.renderCancelButton()}
				</div>
			</div>
		)
	};

	renderSaveArticleButton = () => {
		const {t, savingArticle} = this.props;
		return (
			<Button
				key={"save-btn-article"}
				className="action-button green"
				type="submit"
				onClick={() => {
					this.onSaveButtonPressed()
				}}
			>
				{savingArticle ? <Loading size={"small-spinner"} color={"white"}/> : t('Save')}
			</Button>
		)
	};

	renderSubmitArticleButton = () => {
		const {t, submitingArticle} = this.props;
		return (
			<Button
				key={"submit-btn-article"}
				className="action-button green btn_create_article_main_action"
				type="submit"
				onClick={() => {
					this.onSubmitButtonPressed()
				}}
			>
				{submitingArticle ? <Loading size={"small-spinner"} color={"white"}/> : t('Submit')}
			</Button>
		)
	};

	renderApproveArticleButton = () => {
		const {t, approvingArticle} = this.props;
		return (
			<Button
				key={"approve-btn-article"}
				className="action-button green btn_create_article_main_action"
				type="submit"
				onClick={() => {
					this.onApproveButtonPressed()
				}}
			>
				{approvingArticle ? <Loading size={"small-spinner"} color={"white"}/> : t('Approve')}
			</Button>
		)
	};

	renderMainAction() {
		switch (this.getArticleType()) {

			case DRAFT:
				if (getItem(keys.role) === "1") {
					return [
						this.renderSaveArticleButton(),
						this.renderSubmitArticleButton(),
					]
				} else {
					return [
						this.renderSaveArticleButton(),
						this.renderSubmitArticleButton(),
					]
				}
			case PUBLISHED:
				return this.renderSaveArticleButton();
			case TO_APPROVE:
				if (getItem(keys.role) === "1") {
					return [
						this.renderSaveArticleButton(),
						this.renderApproveArticleButton(),
					]
				} else {
					return this.renderSaveArticleButton();
				}
			case SCHEDULED:
				return this.renderSaveArticleButton();
		}
	}

	renderCancelButton() {
		const {t} = this.props;
		return (
			<Button
				className="action-button grey"
				onClick={this.onBackButtonPressed}
			>
				{t('Cancel')}
			</Button>
		)
	}


	renderSelectMainImageModal() {
		const {isSelectingMainImage} = this.props;
		if (isSelectingMainImage) {
			return (
				<MultimediaModal
					onModalClosed={() => {
						this.props.dispatchOnCreateArticlesIsSelectingMainImageChanged(false)
					}}
					onPositiveActionButtonPressed={(files) => {
						this.onSelectedMainImage(files[0])
					}}
				/>
			)
		}
	}

	renderSelectMultimediaImagesModal() {
		const {isSelectingImages} = this.props;
		if (isSelectingImages) {
			return (
				<MultimediaModal
					onModalClosed={() => {
						this.props.dispatchOnCreateArticlesIsSelectingImagesChanged(false)
					}}
					onPositiveActionButtonPressed={(files) => {
						this.onSelectedImagesForGallery(files)
					}}
					multi={true}
				/>
			)
		}
	}

	renderHasChangesModal() {
		const {t, hasUnsavedChanges, canShowUnsavedChangesModal} = this.props;
		if (hasUnsavedChanges && canShowUnsavedChangesModal) {
			return (
				<SuperModal
					title={t("Unsaved change")}
					okButtonText={t("Keep changes")}
					okButtonColor={"green"}
					cancelButtonText={t("Discard changes")}
					size={"lg"}
					onOkPressed={() => {
						if (this.isCreatingNewArticle()) {
							this.props.dispatchOnCreateArticlesDiscardEditingArticle()
						} else {
							if (this.props.articleToEditUnsaved) {
								this.props.dispatchOnCreateArticlesDiscardUnsavedEditingArticle()
							}
						}
						this.props.dispatchOnCreateArticlesCanShowUnsavedChangesModalChanged(false)
					}}
					onCancelPressed={() => {
						this.onDiscardChanges()
					}}
					onCloseModal={() => {
						this.onDiscardChanges()
					}}
				/>
			)
		}
	}

	renderConfirmAuthorRightsModal() {
		const {t, showHasAuthorRightsModal} = this.props;
		if (showHasAuthorRightsModal) {
			return (
				<SuperModal
					title={t("Author rights")}
					okButtonText={t("Yes, I do")}
					cancelButtonText={t("No")}
					size={"lg"}
					onOkPressed={() => {
						this.props.dispatchOnCreateArticlesHasAuthorRightsChanged(true);
						this.props.dispatchOnCreateArticlesShowHasAuthorRightsModalChanged(false);
						if(actions.current === actions.submit) {
							this.onSubmitArticle()
						} else if (actions.current === actions.approve) {
							this.onApproveArticle()
						}
					}}
					onCancelPressed={() => {
						this.props.dispatchOnCreateArticlesHasAuthorRightsChanged(false)
						this.props.dispatchOnCreateArticlesShowHasAuthorRightsModalChanged(false)
					}}
					onCloseModal={() => {
						this.props.dispatchOnCreateArticlesHasAuthorRightsChanged(false)
						this.props.dispatchOnCreateArticlesShowHasAuthorRightsModalChanged(false)
					}}
				>
					<text>Confirma que tem os direitos de autor para as imagens e textos inseridos neste artigo?</text>
				</SuperModal>
			)
		}
	}

	renderAddArticleToPresentation() {
		const {t, showAddToPresentation, sections} = this.props;
		const animatedComponents = makeAnimated();

		if(!sections || sections.length === 0) return null;

		if (showAddToPresentation) {
			return (
				<SuperModal
					title={"Adicionar artigo à apresentação"}
					okButtonText={"Adicionar"}
					cancelButtonText={"Continuar sem adicionar"}
					size={"lg"}
					onOkPressed={() => {
						this.editLayout();
						this.props.dispatchOnCreateArticlesShowAddToPresentation(false);
					}}
					onCloseModal={() => {
						this.props.dispatchOnCreateArticlesShowAddToPresentation(false)
					}}
				>
					<label className='input-label'>Secção</label>
					<Select
						className="select-multimedia-filter"
						components={animatedComponents}
						options={sections}
						onChange={this.onPresentationSectionChanged}
						defaultValue={sections[0]}
					/>
				</SuperModal>
			)
		}
	}
}

CreateNewArticleMultimedia.defaultProps = {
	mode: 'normal',
};

CreateNewArticleMultimedia.propTypes = {
	mode: PropTypes.oneOf([
		'normal',
		'gallery',
	]),
};

const mapStateToProps = (store) => ({
	strapline: store.createNewArticlesReducer.strapline,
	title: store.createNewArticlesReducer.title,
	lead: store.createNewArticlesReducer.lead,
	body: store.createNewArticlesReducer.body,
	layout: store.createNewArticlesReducer.layout,
	mainImage: store.createNewArticlesReducer.mainImage,
	publishedDate: store.createNewArticlesReducer.publishedDate,
	author: store.createNewArticlesReducer.author,
	images: store.createNewArticlesReducer.images,
	articleToEdit: store.createNewArticlesReducer.articleToEdit,
	articleToEditUnsaved: store.createNewArticlesReducer.articleToEditUnsaved,
	hasUnsavedChanges: store.createNewArticlesReducer.hasUnsavedChanges,
	layouts: store.createNewArticlesReducer.layouts,
	isSelectingMainImage: store.createNewArticlesReducer.isSelectingMainImage,
	isSelectingImages: store.createNewArticlesReducer.isSelectingImages,
	savingArticle: store.createNewArticlesReducer.savingArticle,
	submitingArticle: store.createNewArticlesReducer.submitingArticle,
	approvingArticle: store.createNewArticlesReducer.approvingArticle,
	savingDraft: store.createNewArticlesReducer.savingDraft,
	publishingArticle: store.createNewArticlesReducer.publishingArticle,
	isBodyShowing: store.createNewArticlesReducer.isBodyShowing,
	canShowUnsavedChangesModal: store.createNewArticlesReducer.canShowUnsavedChangesModal,
	errors: store.createNewArticlesReducer.errors,
	hasAuthorRights: store.createNewArticlesReducer.hasAuthorRights,
	showHasAuthorRightsModal: store.createNewArticlesReducer.showHasAuthorRightsModal,
	showAddToPresentation: store.createNewArticlesReducer.showAddToPresentation,
	sections: store.createNewArticlesReducer.sections,
	section: store.createNewArticlesReducer.section,
	newLayout: store.presentationReducer.newLayout,

});

const mapDispatchToProps = {
	dispatchOnCreateArticlesGetSchoolArticlesLayouts,
	dispatchOnCreateArticlesGetSchoolArticlesLayoutsSuccess,
	dispatchOnCreateArticlesGetSchoolArticlesLayoutsFailure,
	dispatchOnCreateArticlesSaveArticle,
	dispatchOnCreateArticlesSaveArticleSuccess,
	dispatchOnCreateArticlesSaveArticleFailure,
	dispatchOnCreateArticlesSubmitArticle,
	dispatchOnCreateArticlesSubmitArticleSuccess,
	dispatchOnCreateArticlesSubmitArticleFailure,
	dispatchOnCreateArticlesApproveArticle,
	dispatchOnCreateArticlesApproveArticleSuccess,
	dispatchOnCreateArticlesApproveArticleFailure,
	dispatchOnCreateArticlesStraplineChanged,
	dispatchOnCreateArticlesTitleChanged,
	dispatchOnCreateArticlesLeadChanged,
	dispatchOnCreateArticlesBodyChanged,
	dispatchOnCreateArticlesLayoutChanged,
	dispatchOnCreateArticlesMainImageChanged,
	dispatchOnCreateArticlesPublishDateChanged,
	dispatchOnCreateArticlesAuthorChanged,
	dispatchOnCreateArticlesImagesChanged,
	dispatchOnCreateArticlesArticleToEditChanged,
	dispatchOnCreateArticlesSetArticleToEditChanged,
	dispatchOnCreateArticlesLayoutsChanged,
	dispatchOnCreateArticlesIsSelectingMainImageChanged,
	dispatchOnCreateArticlesIsSelectingImagesChanged,
	dispatchOnCreateArticlesCreatingNewChanged,
	dispatchOnCreateArticlesSavingDraftChanged,
	dispatchOnCreateArticlesPublishingArticleChanged,
	dispatchOnCreateArticlesSavingArticleChanged,
	dispatchOnCreateArticlesIsBodyShowingChanged,
	dispatchOnCreateArticlesHasUnsavedChangesChanged,
	dispatchOnCreateArticlesCanShowUnsavedChangesModalChanged,
	dispatchOnMultimediaClearSelectedFiles,
	dispatchOnCreateArticlesDiscardNewArticle,
	dispatchOnCreateArticlesDiscardEditingArticle,
	dispatchOnCreateArticlesDiscardUnsavedEditingArticle,
	dispatchOnCreateArticlesFormErrors,
	dispatchOnCreateArticlesHasAuthorRightsChanged,
	dispatchOnCreateArticlesShowHasAuthorRightsModalChanged,
	dispatchOnMultimediaSetSelectedFile,
	dispatchOnCreateArticlesShowAddToPresentation,
	dispatchOnCreateArticlesSectionsChanged,
	dispatchOnCreateArticlesSectionChanged,
	dispatchOnPresentationGetLayouts,
	dispatchOnPresentationGetLayoutsSuccess,
	dispatchOnPresentationGetLayoutsFailure,
};

export default (Connect(mapStateToProps, mapDispatchToProps)(withTranslation("translations")(CreateNewArticleMultimedia)));
